import styled from 'styled-components';
import { Sizing } from '../../styles/spacing';
import { FontSize } from '../../styles/typography';

type TextAlign = 'left' | 'center' | 'right' | 'justify';

type AlignableProps = {
  $textAlign?: TextAlign;
};

export const Header = styled.h2<AlignableProps>`
  margin: 0;
  text-align: ${(p) => p.$textAlign || 'left'};
  font-weight: 550;
`;

export const Paragraph = styled.p<AlignableProps>`
  margin-top: 0;
  margin-bottom: 2rem;
  text-align: ${(p) => p.$textAlign || 'left'};
`;

type TextProps = {
  $padding?: Sizing;
  $margin?: Sizing;
  $fontSize?: FontSize;
  $fontWeight?: 'normal' | 'bold' | 'bolder';
  $color?: string;
  $textAlign?: TextAlign;
};

export const Text = styled.p<TextProps>`
  padding: ${(p) => p.$padding || '0px'};
  margin: ${(p) => p.$margin || '0px'};
  font-size: ${(p) => p.$fontSize || '16px'};
  font-weight: ${(p) => p.$fontWeight || 'normal'};
  color: ${(p) => p.$color || '#000'};
  text-align: ${(p) => p.$textAlign || 'left'};
`;
